import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ListCategories, ListCategorieswithoutpagination } from "../../actions/categoryAction";

import { ListProducts } from "../../actions/productAction";
import Axios from "../../axios/axios";
import Pagination from "../Pagination/Pagination";
const LstProduct = () => {
  const dispatch = useDispatch();

  const [productListData, setProductList] = useState([]);
  const [searchKey, setSearchKey] = useState("");

  const catList = useSelector((state) => state.catList);
  const { loading, error, categories } = catList;

  const productList = useSelector((state) => state.productList);
  // const { products } = productList;
  const [products, setProducts] = useState([]);
  console.log(products);

  const catDelete = useSelector((state) => state.catDelete);

  const [brands, setBrands] = useState([]);
  const [categorydata, setCategoryData] = useState([]);
  const [selectedBrandId, setSelectedBrandId] = useState("all");
  const [selectedCategoryId, setSelectedCategoryId] = useState("all");

  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = catDelete;

  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [perPage] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [pageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // Empty dependency → runs only once on mount

  useEffect(() => {
    getProducts();
  }, [ selectedBrandId, selectedCategoryId, page, keyword]);

  useEffect(() => {
    fetchFilters();
  }, []);

  const fetchFilters = async () => {
    const brandRes = await Axios.get("/api/brand?pageSize=1000&pageNumber=1");
    const categoryRes = await Axios.get("/api/category");
    setBrands(brandRes.data.brands);
    setCategoryData(categoryRes.data.categories);
  };

  const getProducts = async () => {
    try {
      const res = await Axios.get(
        `/api/products?pageNumber=${page}&pageSize=${pageSize}&keyword=${keyword}&category=${selectedCategoryId}&brand=${selectedBrandId}`
      );
      if (res.status >= 200 && res.status < 300) {
        console.log(res.data);
        setProducts(res.data.products);
        console.log(res.data.count);
        setTotalCount(res.data.count);
      }
    } catch (error) {
      console.error("Error fetching packages", error);
    }
  };
  console.log(totalCount, "total count");
  useEffect(() => {
  dispatch(ListCategorieswithoutpagination());
}, [dispatch, successDelete]);

  const deleteHandler = async (id) => {
    if (window.confirm("Are you sure")) {
      await Axios.delete(`/api/products/${id}`);
      window.location.href = "/products";
    }
  };

  const updateActiveStatus = async (id, newStatus) => {
    if (window.confirm("Are you sure you want to update the status?")) {
      try {
        const { data } = await Axios.put(`/api/products/updateActive/${id}`, {
          active: newStatus,
        });
        if (data) {
          window.location.href = "/products";
        }
      } catch (error) {
        console.error("Error updating product status:", error);
      }
    }
  };
  console.log(page, perPage, totalCount);

  return (
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Product List</h4>
            <div class="float-right">
              <Link to="/product/create">
                {" "}
                <button type="button" class="btn btn-primary btn-md btn-block">
                  <i class="icon-plus menu-icon"></i>
                  Create
                </button>
              </Link>
            </div>

            <div className="row mb-3 align-items-end">
              {/* Search Input */}
              <div className="col-md-4">
                <label className="form-label">Search</label>
                <input
                  type="text"
                  placeholder="Search by product name"
                  className="form-control"
                  value={keyword}
                  onChange={(e) => {
                    setKeyword(e.target.value);
                    setPage(1); // Reset to first page on new filter
                  }}
                />
              </div>

              {/* Brand Dropdown */}
              <div className="col-md-4">
                <label className="form-label">Brand</label>
                <select
                  className="form-select"
                  value={selectedBrandId}
                  onChange={(e) => {
                    setSelectedBrandId(e.target.value);
                    setPage(1);
                  }}
                >
                  <option value="all">All</option>
                  {brands.map((brand) => (
                    <option key={brand._id} value={brand._id}>
                      {brand.brandName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Category Dropdown */}
              <div className="col-md-4">
                <label className="form-label">Category</label>
                <select
                  className="form-select"
                  value={selectedCategoryId}
                  onChange={(e) => {
                    setSelectedCategoryId(e.target.value);
                    setPage(1);
                  }}
                >
                  <option value="all">All</option>
                  {categories.map((cat) => (
                    <option key={cat._id} value={cat._id}>
                      {cat.categoryName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Sl No</th>
                    <th>Product Name</th>
                    <th>Category</th>
                    <th> Brand</th>
                    <th> Price</th>
                    {/* <th> */}

                    {/* </th> */}
                  </tr>
                </thead>
                <tbody>
                  {products?.length > 0 ? (
                    products?.map((data, index) => (
                      <tr>
                        <td>{(page - 1) * perPage + index + 1}</td>
                        <td>
                          {" "}
                          <Link to={`/product/${data?._id}`}>{data?.name}</Link>
                        </td>
                        <td>{data?.category?.categoryName}</td>
                        <td>{data?.brand?.brandName}</td>
                        <td>₹ {data?.price}</td>
                        <td>
                          <div class="d-flex flex-wrap">
                            {/* <div class="p-2"> 
                            {/* {' '} */}
                            <div class="p-2">
                              {" "}
                              <button
                                type="button"
                                className={`btn btn-sm ${
                                  data.active
                                    ? "btn-outline-danger"
                                    : "btn=outline-success"
                                }`}
                                onClick={() =>
                                  updateActiveStatus(data?._id, !data.active)
                                }
                              >
                                {data.active ? "Disable" : "Enable"}
                              </button>
                            </div>
                            <Link to={`/product/edit/${data?._id}`}>
                              <button
                                type="button"
                                class="btn btn-outline-dark btn-sm"
                              >
                                Edit
                              </button>
                            </Link>
                            {/* </div> */}
                            <div class="p-2">
                              {" "}
                              <button
                                type="button"
                                class="btn btn-outline-danger btn-sm"
                                onClick={() => deleteHandler(data?._id)}
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6}>No Products Found</td>
                    </tr>
                  )}
                </tbody>
              </table>

              <Pagination
                page={page}
                perPage={perPage}
                setPage={setPage}
                totalCount={totalCount}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LstProduct;
